<!-- 
Provides a standard layout for when we have no data to show on a tab.
-->
<template>
  <p :class="`text-xs-center mt-4 pt-4 mb-${bottomMargin} pb-${bottomMargin}`">
    <slot/>
  </p>
</template>

<script>
export default {
  props: {
    bottomMargin: {
      type: String,
      default: "5"
    }
  }
};
</script>
